export default "__VITE_ASSET__wALxKaC___"